module.exports = __webpack_public_path__ + "img/park-list-cover-2.92edc260.png";